import { ProductAlertMessage } from '@product-detail/models/product-alert-message';
import { TranslateService } from '@ngx-translate/core';
import { Product } from '@shared/models/product.model';

export const getQOEProductWarningMessage = (
  translateService: TranslateService,
  qoeProduct: Product,
  cpnNotFound: boolean,
): ProductAlertMessage => {
  if (qoeProduct?.notFound === true || cpnNotFound === true) {
    return {
      display: true,
      primaryText: translateService.instant(
        'i18n.orderInfoSidebar.quickOrderWidget.noProductFound',
      ),
      secondaryText: '',
    };
  } else if (
    qoeProduct?.summary?.cashCarryIndicator === '2' ||
    qoeProduct?.summary?.cashCarryIndicator === '3'
  ) {
    return {
      display: true,
      primaryText: translateService.instant(
        'i18n.orderInfoSidebar.quickOrderWidget.unableToOrder',
      ),
      secondaryText: translateService.instant(
        'i18n.orderInfoSidebar.quickOrderWidget.productIsCashAndCarry',
      ),
    };
  } else if (qoeProduct?.productCardWarningMsg?.display === true) {
    return qoeProduct.productCardWarningMsg;
  }
};
